import { ROUTE_PATH } from './utils';

// Used by admin pages that live outside /admin-panel (e.g. the order search page) so their own
// AdminNav sidebar can jump back into a specific admin-panel tab, or to another standalone
// route, instead of being a dead click.
export const navigateToAdminNavItem = (navigate, item) => {
  if (item.route) {
    navigate(item.route);
  } else {
    navigate(ROUTE_PATH.ADMIN_PANEL, { state: { activeKey: item.key } });
  }
};
